import { render, staticRenderFns } from "./ThreadOnboardingWelcome.vue?vue&type=template&id=4d426f7b&scoped=true"
import script from "./ThreadOnboardingWelcome.vue?vue&type=script&lang=js"
export * from "./ThreadOnboardingWelcome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d426f7b",
  null
  
)

export default component.exports